import PostEditableItem from './PostEditableItem';
import PostEditableItemContainer from './PostEditableItem.container';

export default PostEditableItemContainer(PostEditableItem);
